import { useState, useEffect } from 'react';

/**
 * Hook personalizado que persiste el estado en sessionStorage
 * @param key - Clave única para almacenar en sessionStorage
 * @param initialValue - Valor inicial si no existe en sessionStorage
 * @returns Tupla [state, setState] similar a useState
 */
export function useSessionState<T>(key: string, initialValue: T): [T, React.Dispatch<React.SetStateAction<T>>] {
  // Inicializar estado desde sessionStorage o valor inicial
  const [state, setState] = useState<T>(() => {
    try {
      const item = sessionStorage.getItem(key);
      if (item === null) {
        return initialValue;
      }
      return JSON.parse(item) as T;
    } catch (error) {
      console.warn(`[useSessionState] Error al leer ${key} desde sessionStorage:`, error);
      return initialValue;
    }
  });

  // Guardar en sessionStorage cuando cambie el estado
  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(state));
    } catch (error) {
      console.warn(`[useSessionState] Error al guardar ${key} en sessionStorage:`, error);
    }
  }, [key, state]);

  return [state, setState];
}

